import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ColumnSortService } from 'src/app/components/dynamic-data-list/services/column-sort.service';
import { Subscription } from 'rxjs';

@Component({
    selector: '[sortable-column]',
    templateUrl: './sortable-column.component.html',
    styleUrls: ['./sortable-column.component.scss'],
    standalone: false
})
export class SortableColumnComponent implements OnInit, OnDestroy {

  constructor(private sortService: ColumnSortService) { }

  @Input('sortable-column')
  columnName: string;

  @Input('sort-direction')
  sortDirection: string = '';

  @Input('data-type')
  dataType: string;

  private columnSortedSubscription: Subscription;

  @HostListener('click')
  sort() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      this.sortService.sortByColumn({ sortColumn: this.columnName, sortDirection: this.sortDirection, dataType: this.dataType });
  }

  ngOnInit() {
      // subscribe to sort changes so we can react when other columns are sorted
      this.columnSortedSubscription = this.sortService.sortColumn$.subscribe(event => {
          // reset this column's sort direction to hide the sort icons
          if (this.columnName != event.sortColumn) {
              this.sortDirection = '';
          }
      });
  }

  ngOnDestroy() {
      this.columnSortedSubscription.unsubscribe();
  }

}
